import { css } from "@emotion/css";
import { Colors, Spacing } from "@snapchat/snap-design-system";

export const newTagClassName = css`
    margin-inline-start: ${Spacing.XS}px;
    background-color: ${Colors.Yellow.V200};
    border: none;
`;
